interface Data {
  error: string,
  session: {
    id: string,
    sessionData: string
  } | null,
  paymentMethods?: Array<PaymentMethod>
  config?: {
    environment: string,
    clientKey: string,
    analytics: {
      enabled: boolean
    }
  }
  redirectUrl?: string
}

interface PaymentMethod {
  name: string,
  type: string
}

export const data: Data = {
  error: "",
  session: null,
  config: undefined,
  redirectUrl: undefined,
}
